import { Box, Text } from '@mantine/core'
import { useMemo } from 'react'

import CoinIcon from '@/components/CoinIcon'
import useCoinPriceChange from '@/hooks/business/useCoinPriceChange'
import { useCurrencyAmounts } from '@/hooks/business/useCurrencyAmounts'
import { useI18nRouter } from '@/i18n/navigation'
import { formatSlugForApi } from '@/services/coin/market'
import { CryptoBasketCoin } from '@/types/invest'

import styles from './styles.module.css'

export default function CoinCard({ name }: Pick<CryptoBasketCoin, 'name'>) {
  const router = useI18nRouter()
  const { coinMarket, percentage, changeColor, changeSymbol } = useCoinPriceChange(name)

  const {
    currency,
    amounts: [{ formattedValue }],
  } = useCurrencyAmounts({
    amounts: [coinMarket?.usd_price || 0],
    tokenSymbol: name,
    isUsedForTokenPrice: true,
    isExchangeRateBasedOnSymbolCurrency: false,
  })

  const coinDetailUrl = useMemo(() => `/${formatSlugForApi(name)}`, [name])

  if (!coinMarket) return null
  return (
    <Box
      className={styles.container}
      p={16}
      onClick={() => {
        router.push(coinDetailUrl)
      }}
    >
      {/* Coin Info */}
      <CoinIcon coin={coinMarket} size={48} />
      <Text variant="heading3" mt={16}>
        {name}
      </Text>

      {/* Price Info */}
      <Box>
        <Text variant="heading2">{`${currency.symbol}${formattedValue}`}</Text>
        <Text variant="subtitle" style={{ color: changeColor }}>
          {`${changeSymbol}${percentage} YTD`}
        </Text>
      </Box>
    </Box>
  )
}
